import React from "react";
import Control from "react-leaflet-control";
import DepthMap from "./../Icons/images/depthMap.png";
import "./depthLegend.scss";

/**
 * A legend for the depth map
 */
const DepthLegend = (props) => {
  return (
    <Control position="bottomright">
      <div className="depthLegend">
        <img
          style={{ height: "20>0px" }}
          src={DepthMap}
          alt="dybdekortforklaring"
        />
      </div>
    </Control>
  );
};

export default DepthLegend;
